export default "__VITE_ASSET__DXnwusvy__"